import { brickConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function BrickPage() {
  return <CityPageTemplate config={brickConfig} />;
}